import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Tr, Td } from "commons";
import { convertToMoney } from "commons/src/Money";
import { getDefaultAnalysisDateRange } from "commons/src/NuDateUtils";
import { format, FORMAT } from "commons/src/NuDateUtils";
import { isPrintMode } from "commons/src/QueryParameter";

import { AccountLink } from "./AccountLink";
import { FolioTable } from "../FolioDetails/FolioTable";

const DEFAULT_RANGE = getDefaultAnalysisDateRange().id;

export function WrapperIncome({ wrapperDetails, accountNumber }) {
    const {
        maxIncomeAmount,
        accountIncomeCTY,
        drawdownType,
        taxCode,
        reviewFrequency,
        nextReviewDate
    } = wrapperDetails;

    return (
        <Fragment>
            <FolioTable data-testid="wrapper-income-table" dense={isPrintMode()}>
                <tbody>
                    {drawdownType !== "Flexi-access" && (
                        <Tr>
                            <Td align="left">Max income amount</Td>
                            <Td data-testid="max-income-amount" align="right">
                                {convertToMoney(maxIncomeAmount)}
                            </Td>
                        </Tr>
                    )}
                    <IncomeRow>
                        <Td align="left">Total income</Td>
                        <Td data-testid="income-cty" align="right">
                            {convertToMoney(accountIncomeCTY)}
                        </Td>
                    </IncomeRow>
                    <Tr>
                        <Td align="left">Type of drawdown</Td>
                        <Td data-testid="drawdown-type" align="right">
                            {drawdownType}
                        </Td>
                    </Tr>
                    <Tr>
                        <Td align="left">Tax code</Td>
                        <Td data-testid="tax-code" align="right">
                            {taxCode || "-"}
                        </Td>
                    </Tr>
                    {drawdownType !== "Flexi-access" && (
                        <Fragment>
                            <Tr>
                                <Td align="left">Review frequency</Td>
                                <Td data-testid="review-freq" align="right">
                                    {reviewFrequency}
                                </Td>
                            </Tr>
                            <Tr>
                                <Td align="left">Next review date</Td>
                                <Td data-testid="next-review-date" align="right">
                                    {format(nextReviewDate, FORMAT.SLASH_SEPARATED_ABBR_YR)}
                                </Td>
                            </Tr>
                        </Fragment>
                    )}
                </tbody>
            </FolioTable>
            <NoPrintLinkContainer>
                <AccountLink
                    data-testid="income-history-link"
                    label="Income history"
                    target="incomeHistory"
                    account={accountNumber}
                    range={DEFAULT_RANGE}
                />
            </NoPrintLinkContainer>
        </Fragment>
    );
}

const IncomeRow = styled(Tr)`
    @media print, (min-width: ${props => props.theme.maxWidth}) {
        display: none;
    }
`;

const NoPrintLinkContainer = styled.div`
    display: flex;

    @media (max-width: 600px) {
        justify-content: center;
    }

    @media (min-width: 601px) {
        justify-content: flex-end;
    }

    @media print {
        display: none;
    }
`;

WrapperIncome.propTypes = {
    wrapperDetails: PropTypes.object,
    accountNumber: PropTypes.string
};
